module.exports = __webpack_public_path__ + "media/images/turbotrucks-d324ca1867ad6f56b28b8e06d5ba1766.svg";